import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

// @ts-ignore
import { useLazyListRecordsQuery } from "../api/managementApi.js";
import {
  NonStoredRecord,
  RecordResponseType,
  RecordType,
} from "../utils/types/api/RecordResponseType.js";

type Args = {
  projectId: string;
};

const useGetProjectRecords = ({ projectId }: Args) => {
  const [getRecords, { data: recordsData }] = useLazyListRecordsQuery();
  const [allRecords, setAllRecords] = useState<RecordResponseType[]>([]);

  const { allowedRecordTypes } = useSelector((state: any) => state.project);
  const { nonStored, searchText, filterAreaTypes } = useSelector(
    (state: any) => state.records,
  );

  const requiredRecordTypes = useMemo(
    () =>
      allowedRecordTypes.filter(
        (recordType: RecordType) => recordType !== "SOLAR_PANEL",
      ),
    [allowedRecordTypes],
  );

  useEffect(() => {
    if (!projectId) return;

    try {
      getRecords({
        projectId,
        searchString: searchText,
        areaRecordType: filterAreaTypes,
        recordTypes: requiredRecordTypes,
      });
    } catch (error) {
      console.error("Search records error:", error);
    }
  }, [searchText, projectId, filterAreaTypes, requiredRecordTypes, getRecords]);

  useEffect(() => {
    const records = recordsData?.records || [];

    const storedWithoutLocal = records.filter(
      (r: RecordResponseType) =>
        !nonStored.some((nr: NonStoredRecord) => nr.id === r.id),
    );

    const allRec: RecordResponseType[] = [...storedWithoutLocal, ...nonStored];

    setAllRecords(allRec);
  }, [recordsData, nonStored]);

  return {
    records: allRecords,
    extra: recordsData?.extra,
  };
};

export default useGetProjectRecords;
